// Image helpers for receipt photo upload (used by NewExpenseModal).

export async function fileToBase64DataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error('Nepodarilo sa prečítať obrázok.'));
    reader.readAsDataURL(file);
  });
}
